export var OrganizationType;
(function (OrganizationType) {
    // EB_INTERNAL, CUSTOMER_INTERNAL, DISCONTINUED, CUSTOMER, INSTALLER_PARTNER
    OrganizationType["EB_INTERNAL"] = "EB_INTERNAL";
    OrganizationType["INSTALLER_PARTNER"] = "INSTALLER_PARTNER";
    OrganizationType["CUSTOMER"] = "CUSTOMER";
    OrganizationType["CUSTOMER_INTERNAL"] = "CUSTOMER_INTERNAL";
    OrganizationType["DISCONTINUED"] = "DISCONTINUED";
})(OrganizationType || (OrganizationType = {}));
